var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.597 18.2473L9.79297 18.2473L9.79297 16.7473L19.597 16.7473L19.597 18.2473Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.34184 18.936C8.13644 18.936 8.7806 18.2918 8.7806 17.4972C8.7806 16.7026 8.13644 16.0585 7.34184 16.0585C6.54723 16.0585 5.90308 16.7026 5.90308 17.4972C5.90308 18.2918 6.54723 18.936 7.34184 18.936ZM7.34184 20.436C8.96487 20.436 10.2806 19.1203 10.2806 17.4972C10.2806 15.8742 8.96487 14.5585 7.34184 14.5585C5.7188 14.5585 4.40308 15.8742 4.40308 17.4972C4.40308 19.1203 5.7188 20.436 7.34184 20.436Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40302 8.25281L14.207 8.25281L14.207 6.75281L4.40302 6.75281L4.40302 8.25281Z",
    fill: "#1F1F1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6582 8.94149C15.8636 8.94149 15.2194 8.29733 15.2194 7.50273C15.2194 6.70812 15.8636 6.06396 16.6582 6.06396C17.4528 6.06396 18.0969 6.70812 18.0969 7.50273C18.0969 8.29733 17.4528 8.94149 16.6582 8.94149ZM16.6582 10.4415C15.0351 10.4415 13.7194 9.12576 13.7194 7.50273C13.7194 5.87969 15.0351 4.56396 16.6582 4.56396C18.2812 4.56396 19.5969 5.87969 19.5969 7.50273C19.5969 9.12576 18.2812 10.4415 16.6582 10.4415Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIc);
export default __webpack_public_path__ + "static/media/filter_ic.0fdf72af.svg";
export { ForwardRef as ReactComponent };